import { createTheme } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';
import { muiTypography } from './muiTypography';
import { muiPalette } from './muiPalette';
const { breakpoints: muiBreakpoints, spacing: muiSpacing } = createTheme();

export const tabsOverride = {
  MuiTabs: {
    defaultProps: {
      'data-qa-id': 'tabs'
    },
    styleOverrides: {
      flexContainer: ({ ownerState }) => ({
        ...(ownerState.orientation !== 'vertical' && {
          borderBottom: `1px solid ${muiPalette.palette.divider}`,
          width: 'fit-content'
        }),
        ...(ownerState.withIcons &&
          ownerState.orientation !== 'vertical' && {
            height: '48px',
            alignItems: 'center'
          })
      }),
      flexContainerVertical: {
        borderBottom: 'none',
        borderRight: `1px solid ${muiPalette.palette.divider}`,
        '& .MuiTab-root': {
          justifyContent: 'flex-start',
          textAlign: 'start',
          minHeight: '32px',
          marginTop: 20,
          marginRight: 0,
          padding: `0px ${muiSpacing(3)}`,
          maxWidth: '215px',
          width: '100%',
          '&:first-child': {
            marginTop: 0
          },
          '&>*': {
            width: 'max-content'
          }
        }
      }
    }
  }
};

export const tabOverride = {
  MuiTab: {
    defaultProps: {
      iconPosition: 'start',
      'data-qa-id': 'tab'
    },
    styleOverrides: {
      root: ({ ownerState }) => ({
        padding: '0 0',
        marginRight: 20,
        [muiBreakpoints.up('sm')]: {
          minWidth: 'fit-content'
        },
        textTransform: 'unset',
        ...muiTypography.typography.button,
        '&:hover': {
          color: muiPalette.palette.primary.main,
          '& .MuiSvgIcon-root.MuiSvgIcon-root': {
            color: muiPalette.palette.primary.main
          }
        },
        '&.MuiTab-labelIcon': {
          paddingTop: 0
        },
        '&.Mui-focusVisible': {
          background: muiPalette.palette.action.focus
        },
        '&.Mui-selected': {
          '& .MuiSvgIcon-root.MuiSvgIcon-root': {
            color: muiPalette.palette.primary.main
          }
        },
        ...((ownerState.WithBadge || ownerState.withCounter) && {
          gap: muiSpacing(0.5),
          whitespace: 'pre',
          [`&.${tabClasses.root}>*`]: {
            '.MuiBadge-badge': {
              height: '20px'
            },
            display: 'flex',
            whitespace: 'pre'
          }
        }),
        ...(ownerState.orientation === 'vertical' && {
          backgroundColor: 'red'
        }),
        ...(ownerState.icon &&
          ownerState.label && {
            [`& > .${tabClasses.iconWrapper}`]: {
              ...(ownerState.iconPosition === 'start' && {
                fontSize: 20,
                marginRight: muiSpacing(0.5),
                marginBottom: 0,
                color: !ownerState.disabled
                  ? muiPalette.palette.grey[600]
                  : muiPalette.palette.action.disabled
              })
            }
          })
      }),
      textColorPrimary: {
        color: muiPalette.palette.text.secondary
      },
      labelIcon: {
        minHeight: undefined
      }
    }
  }
};
